import GoalTracker from "./GoalTracker";
import gsap from 'gsap';

export class HeartAnimationElement extends window.HTMLElement {
  heartMarkup = `<svg class="animation__svg heart--simple" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 17">
      <path d="M17.801 1.837c-3.705-3.51-7.8 1.56-7.8 1.56S5.905-1.48 2.2 1.837c-4.095 3.705.78 10.335 7.8 13.846 7.216-3.51 11.896-10.336 7.801-13.846Z" fill="#FFC399" stroke="#FB6B21" stroke-width="1.047" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="animation__svg heart" id="heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40">
      <path d="M43.565 4.23c-9.253-8.46-19.118 3.847-19.118 3.847S14.277-2.846 5.329 4.23c-5.276 4.154-4.511 11-.611 17.384C8.618 28 15.806 34.308 24.523 38.54 41.806 30.076 53.43 13.384 43.565 4.23Z" fill="#FFDFCA"/>
      <path d="M1.506 7.846s4.512.077 9.253 5.385c5.735 6.461 6.041 15.615 10.63 18.615 3.823 2.462 10.17 2.77 10.17 2.77l-6.653 3.922c-.077 0-22.788-10.23-23.4-30.692Z" fill="#FFC197"/>
      <path d="M43.565 4.23c-9.253-8.46-19.118 3.847-19.118 3.847S14.277-2.846 5.329 4.23c-5.276 4.154-4.511 11-.611 17.384C8.618 28 15.806 34.308 24.523 38.54 41.806 30.076 53.43 13.384 43.565 4.23Z" fill="none" stroke="#FF6B00" stroke-width="2.16" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M37.523 6.077s3.671.692 5.2 5.384" stroke="#fff" stroke-width="2.16" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>`;

  styles = `.animation__svg {
    width: 40px;
    transform: translatex(-50%);
    bottom: 40px;
    position: absolute;
  }

  .heart {
    transform-origin: "bottom center";
  }

  .heart--simple {
    opacity: 0;
    visibility: hidden;
  }
  
  .heart-animation__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
   }`;

  constructor(goalRef) {
    super();
    this.attachShadow({mode: 'open'});
    this.goalRef = this.getAttribute("goalRef", goalRef);
    const position = this.getPosition();

    if (!position) {
      console.warn(`No element found with goalRef ${this.goalRef}`);
      return;
    }

    this.wrapperElement = window.document.createElement("div");
    this.wrapperElement.setAttribute("id", `heart-animation-${this.goalRef}`);
    this.wrapperElement.setAttribute("class", "heart-animation__wrapper");
    this.wrapperElement.innerHTML = this.heartMarkup;
    this.wrapperElement.style.display = "none";
    this.addStyle();

    this.style.position = "fixed";
    this.style.top = `${position.top + 16}px`;
    this.style.right = `${position.right + 10}px`;

    this.goalTrackerInstance = GoalTracker.getInstance(this.goalRef);
    this.goalTrackerInstance.addHeartAnimationElement(this.wrapperElement);

    this.shadowRoot.append(this.wrapperElement);
    this.init();
  }
  
  init() {
    this.eventListeners();
    // this.heartAnimation = new HeartAnimation(this.wrapperElement);
  }

  getPosition() {
    const goalTrackerElement = window.document.querySelector(`wv-goal-tracker[goalRef="${this.goalRef}"]`);
    const gtPosition = (goalTrackerElement) ? goalTrackerElement.getBoundingClientRect() : null;
    return gtPosition;
  }

  eventListeners() {
    // Listen for screen resize and update position
    window.addEventListener("resize", () => {
      const position = this.getPosition();
      this.style.top = `${position.top + 16}px`;
      this.style.left = `${position.right - 10}px`;
    });
  }

  addStyle() {
    const styleTag = document.createElement('style');
    styleTag.textContent = this.styles;

    this.shadowRoot.append(styleTag);
  }
}
